export default __webpack_public_path__ + "static/media/womenHijab.7f4a9029.svg";